<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <div class="tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center">
            <h2>Call <strong>(877)-360-3843</strong> now<br class="lg:tw-hidden"> to <strong>get a free quote</strong></h2>
        </div>
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <fieldset class="tw-grid tw-grid-cols-1 tw-px-3 tw-pb-3 tw-pt-4 tw-gap-2 lg:tw-grid-cols-2 lg:tw-px-12 lg:tw-pt-8 lg:tw-gap-3">
                <!-- <div class="input-group input-group-phone">
                    <input type="text"
                        placeholder=" "
                    >
                    <label>
                        <strong>(877)-360-3843</strong>
                    </label>
                </div> -->
                <validation-provider class="tw-w-full tw-w-block" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text"
                            placeholder=" "
                            v-model="fullName"
                        >
                        <label>
                            First and Last Name
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|phone:us" v-slot="{ classes }">
                    <div class="input-group input-group-phone_alt" :class="classes">
                        <input type="tel"
                            placeholder=" "
                            v-model="phone"
                            v-mask="'###-###-####'"
                        >
                        <label>
                            Phone
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|email" v-slot="{ classes }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="email"
                            placeholder=" "
                            v-model.lazy="email"
                        >
                        <label>
                            Email
                        </label>
                    </div>
                </validation-provider>
                <div class="tw-text-center">
                    <button
                        type="submit"
                        class="btn-cta"
                        :disabled="formLoading"
                    >
                        Start your quote
                    </button>
                </div>
            </fieldset>
            <div>
                <div class="form-check tw-px-3 lg:tw-px-12">
                    <label class="form-check-label">
                        <span>By clicking the “Start your quote” button, you consent for Vivint, and its service provider Aktify, to use automated technology, including calls, texts and prerecorded messages, to contact you at the number and email provided about Vivint offers. This consent is not required to make a purchase. Clicking the button below constitutes your electronic signature.</span>
                    </label>
                </div>
            </div>
        </form>
    </validation-observer>
</template>

<script>
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',

            formLoading: false,
            usedClasses: ['.has-error'],
        };
    },
    mounted() {
        KWKUniJS.ptag({
            zone: 'lead_inscription',
            siteType: 'd',
        });
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            let cmpInfo = {
                vendor:{
                    consents: [],
                },
                tcString: '',
            };

            try{
                cmpInfo = __tcfapi('getTCData');
            } catch (e) {
                console.log('No CMP Info');
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                user_agent: window.navigator.userAgent,
                pubid: this.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                ua_device: this.$store.state.ua_device,
                ua_browser: this.$store.state.ua_browser,
                ua_os: this.$store.state.ua_os,
                token: this.$store.state.token,

                fullName: this.fullName,
                phone: this.phone,
                email: this.email,
                cible: this.$route.query.cible,

                consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                tcString: cmpInfo.tcString,
                mclic: process.env.VUE_APP_MCLIC,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                    KWKUniJS.ptag({
                        zone: 'lead_confirmation',
                        id_lead: response.data.argann,
                        siteType: 'd',
                    });
                })
                .catch((error) => {
                    this.formLoading = false;
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';

h2 {
    padding: 8px 0 9px 0;
    width: 100%;
    background-color: $main_color;
    color: #fff;
    font-size: 18px;
    line-height: 22px;
    @screen lg {
        padding: 0 32px;
        width: fit-content;
        border-radius: 5px;
        font-size: 26px;
        line-height: 62px;
    }
}

.form {
    background-color: #fff;
    box-shadow: 0 4px 4px -2px #707070;
    @screen lg {
        margin: 0 auto;
        max-width: 680px;
        border-radius: 5px;
        transform: translateY(-10px);
    }
}

</style>
